export default {
	controls: {
		next: "Next",
		prev: "Previous",
		done: "Finish",
		progressSeparator: "of",
	},
	welcome: {
		title: "Welcome to ORI!",
		description: "ORI is a spiritual management system for temples. Let's take a quick tour through the system modules so you can discover everything that's available.",
		recommended: "Highly recommended",
		start: "Start Guided Tour",
		skip: "Skip for now",
	},
	helpPanel: {
		title: "Page Help",
		rewatchTour: "Rewatch Guided Tour",
	},
	guided: {
		assistant: {
			title: "Virtual assistant",
			description: "And whenever you need help, talk to the assistant. It answers questions, shows you where to click and helps set up your temple step by step — just click this button anytime.",
		},
		dashboard: {
			title: "Dashboard",
			description: "The system's home page. Here you see a quick summary: your data, the active ritual, scheduled ones, quick charts and today's birthdays.",
		},
		consultants: {
			title: "Consultants",
			description: "People who visit the temple to receive spiritual care. Register, search and manage all consultants.",
		},
		mediums: {
			title: "Mediums",
			description: "Members of the temple's mediumistic body. Manage medium registrations, roles and spiritual lines. Add a journey to a consultant to integrate them into the spiritual chain.",
		},
		journeyStages: {
			title: "Journey Stages",
			description: "Stages a person goes through in the temple (e.g.: Visitor, Initiate, Developed). Each person can be at a specific stage.",
		},
		functions: {
			title: "Functions",
			description: "Roles that mediums perform in rituals (e.g.: Cambono, Ogã, Pai/Mãe de Santo). Assign functions to people.",
		},
		memberGroups: {
			title: "Groups",
			description: "Organize people into groups for easier management. Create groups by purpose (e.g.: Study Group, Healing Chain) and assign members.",
		},
		spiritualLines: {
			title: "Spiritual Lines",
			description: "Spiritual lines that work in the house. E.g.: Line of Pretos Velhos, Line of Caboclos, Line of Children.",
		},
		guides: {
			title: "Spiritual Guides",
			description: "Entities that serve people in the temple. Register guides and associate them with people to maintain spiritual records.",
		},
		orixas: {
			title: "Orixás",
			description: "Deities worshipped in the temple. Register orixás and associate them with people to record their spiritual crown and connections.",
		},
		attendanceTypes: {
			title: "Ticket Types",
			description: "Available attendance categories (e.g.: Consultation, Pass, Cleansing). Create them according to your house's needs. These tickets are later linked to rituals.",
		},
		ritualTypes: {
			title: "Ritual Types",
			description: "Categories of rituals practiced in the temple (e.g.: Caboclo Gira, Healing Session). Each created ritual is associated with a type.",
		},
		rituals: {
			title: "Rituals",
			description: "Rituals held at the temple. Create, start, manage and close rituals. Each ritual generates tickets, calls and attendance records.",
		},
		financialDashboard: {
			title: "Financial",
			description: "Temple financial dashboard. Track income, expenses and overall balance. Consolidated view of all financial movement.",
		},
		financialFunds: {
			title: "Funds",
			description: "Manage the temple's funds. Create funds, register contributions and track income movements.",
		},
		financialMovements: {
			title: "Movements",
			description: "Complete history of all temple financial movements. Filter by period, fund, type and status.",
		},
		financialReports: {
			title: "Financial Reports",
			description: "Detailed reports on the financial situation. Monthly closings, balances and analysis by period.",
		},
		templeSettings: {
			title: "Temple Settings",
			description: "Edit temple data, contact, address, schedule and visual identity. Configure printing, email, attendance and financial settings.",
		},
		templeUsers: {
			title: "Users",
			description: "See who has access to the system, their roles (Owner, Admin, Member) and activity status.",
		},
		templeInvites: {
			title: "Invites",
			description: "Send email invitations for new people to access the system. Track the status of each invite.",
		},
		wisdomQuotes: {
			title: "Wisdom Quotes",
			description: "Manage wisdom quotes displayed on the dashboard and temple messages. Add, edit or disable quotes.",
		},
		billing: {
			title: "Plan & Subscription",
			description: "Check the temple's current plan, trial period and subscription information.",
		},
		displayMessages: {
			title: "Display Messages",
			description: "Manage messages displayed on ORI TV. Create notices, reminders and announcements for the temple's display.",
		},
		import: {
			title: "Import",
			description: "Bulk import data into the system. Upload spreadsheets with people records to speed up migration.",
		},
		support: {
			title: "Support",
			description: "Direct channel with the ORI team. Open tickets for questions, suggestions or technical issues and track their status.",
		},
	},
	pages: {
		Dashboard: "The Dashboard is the system's home page. Here you see a quick summary: your data, the active ritual, scheduled ones, quick charts and today's birthdays.",
		Consultants: "Consultants are people who visit the temple to receive spiritual care. Here you register, search and manage all consultants.",
		Mediums: "Mediums are members of the temple's mediumistic body. Here you manage all medium registrations, including roles and spiritual lines. Add a journey to a consultant to integrate them into the spiritual chain.",
		SpiritualLines: "Spiritual lines that work in the house. E.g.: Line of Pretos Velhos, Line of Caboclos, Line of Children.",
		Guides: "Spiritual guides are entities that serve people in the temple. Register guides and associate them with people to maintain spiritual records.",
		Orixas: "Orixás are deities worshipped in the temple. Register orixás and associate them with people to record their spiritual crown and connections.",
		RitualTypes: "Ritual types define the categories of rituals practiced in the temple. Each created ritual is associated with a type.",
		Rituals: "Rituals held at the temple. Here you create, start, manage and close rituals. Each ritual generates tickets, calls and attendance records.",
		JourneyStages: "Journey stages represent the stages a person goes through in the temple. Each person can be at a specific stage.",
		Functions: "Functions define the roles that mediums perform in rituals. Assign functions to people to organize the mediumistic body.",
		MemberGroups: "Groups allow you to organize people by purpose. Create groups, add members and manage collective assignments.",
		AttendanceTypes: "Available attendance categories (e.g.: Consultation, Pass, Cleansing). Create them according to your house's needs. These tickets are later linked to rituals.",
		FinancialDashboard: "Temple financial dashboard. Track income, expenses and overall balance. Consolidated view of all financial movement.",
		FinancialFunds: "Manage the temple's funds. Create funds, register contributions and track income movements.",
		FinancialMovements: "Complete history of all temple financial movements. Filter by period, fund, type and status.",
		FinancialReports: "Detailed reports on the financial situation. Monthly closings, balances and analysis by period.",
		TempleSettings: "Temple settings let you edit data, contact, address, schedule and visual identity. Configure printing, email, attendance and financial settings.",
		TempleUsers: "Temple user management. See who has access to the system, their roles and activity status.",
		TempleInvites: "Temple invitation system. Send email invitations for new people to access the system.",
		WisdomQuotes: "Wisdom quotes displayed on the dashboard and temple messages. Add, edit or disable quotes.",
		Billing: "Check the temple's current plan, trial period and subscription information.",
		DisplayMessages: "Manage messages displayed on ORI TV. Create notices, reminders and announcements for the temple's display.",
		Import: "Bulk import data into the system. Upload spreadsheets with people records to speed up migration.",
		Support: "Direct channel with the ORI team. Open tickets for questions, suggestions or technical issues and track their status.",
	},
};
